import React from 'react'
import irelandApi from '../irelandApi';
import qs from 'qs';
import { actions } from 'react-redux-form';
import { toast } from 'react-toastify';
import ToastMessage from '../components/common/toast-message';
import store from '../store';
import * as moment from 'moment';

const assembleStaffMember = (payLoad) => {
  const mPayLoad = {...payLoad};
  mPayLoad.staff_permission_ids = [];
  Object.keys(payLoad.permission_ids).forEach(function (key) {
    if(payLoad.permission_ids[key].checked === 'true'){
      mPayLoad.staff_permission_ids.push(key);
    }
  });
  delete mPayLoad.permission_ids;
  return mPayLoad;
};

export const getStaff = () => (dispatch) => {
  dispatch({type: "GET_STAFF_PENDING", payLoad: []});
  return irelandApi.get('/api/my_staff_members')
                   .then((response) => {
                     dispatch({type: "GET_STAFF_FULFILLED", payLoad: response.data});
                   })
                   .catch((error) => {
                     dispatch({type: 'GET_STAFF_REJECTED', payLoad: error.data})
                   })
};

export const resendInvitation = (resendLink) => (dispatch) => {
  dispatch({type: "RESEND_STAFF_INVITATION_PENDING", payLoad: []});
  return irelandApi.get(resendLink)
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success" message="Invitation has been resent successfully"/>);
                     dispatch({type: "RESEND_STAFF_INVITATION_FULFILLED", payLoad: response.data});
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error" message="An error occured during resend invitation"/>);
                     dispatch({type: 'RESEND_STAFF_INVITATION_REJECTED', payLoad: error.data})
                   })
};

export const addStaff = (link) => (dispatch) => {
  dispatch({type: "ADD_STAFF_PENDING"});
  return irelandApi.get('/api/my_staff_members/new')
                   .then((response) => {
                     if(!link){
                       const permission_ids = {};
                       let data = response.data.data;
                       data.relationships.permissions.forEach(item => {
                         permission_ids[item.id] = {
                           name: item.name,
                         }
                       });

                       const staff_member = {
                         title: '',
                         job_title: '',
                         first_name: '',
                         last_name: '',
                         mobile: '',
                         email: '',
                         outlet_id: '',
                         agreed: false,
                         permission_ids: permission_ids
                       };

                       dispatch(actions.load('deep.staff_member', staff_member));
                     }
                     dispatch({type: "ADD_STAFF_FULFILLED", payLoad: response.data});
                   })
                   .catch((error) => {
                     dispatch({type: 'ADD_STAFF_REJECTED', payLoad: error.data})
                   });
};

export const inviteStaff = (payload) => {
  store.dispatch({ type: "SAVE_STAFF_MEMBER_PENDING" });

  return irelandApi.post('/api/my_staff_members/invite', { my_staff_member: assembleStaffMember(payload) })
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success" message="Invitation has been sent successfully" />);
                     store.dispatch(actions.reset('deep.staff_member'));
                     store.dispatch(getStaff());
                     store.dispatch({ type: "SAVE_STAFF_MEMBER_FULFILLED", payLoad: response.data });
                   })
                   .catch((error) => {
                      toast.error(<ToastMessage iconStyle="error" message="An error occured during invite" />);
                      store.dispatch({ type: "SAVE_STAFF_MEMBER_REJECTED" });
                      store.dispatch(actions.resetValidity('deep.staff_member'));

                      const data = {...error.response.data.errors};

                      return Promise.reject(data)
                   });
};

export const getStaffMember = (getLink, row, status) => (dispatch) => {
  dispatch({type: "GET_STAFF_MEMBER_PENDING", payLoad: []});
  return irelandApi.get(getLink)
                   .then((response) => {
                     let data = response.data.data;
                     const permission_ids = {};
                     data.attributes.permissions.forEach(item => {
                       permission_ids[item.id] = {
                         name: item.name,
                         checked: ''+item.checked
                       }
                     });

                     const staff_member = {
                       title: data.attributes.title,
                       first_name: data.attributes['first-name'],
                       last_name: data.attributes['last-name'],
                       mobile: data.attributes.mobile || '',
                       email: data.attributes.email || '',
                       outlet_id: ''+data.attributes.outlet,
                       permission_ids: permission_ids
                     };

                     dispatch(actions.load('deep.staff_member', staff_member));
                     dispatch({type: "SHOW_EDIT_STAFF", payLoad: data, saveLink: data.links.update, removeLink: data.links['remove-from-store'], show: row, status: status});
                   })
                   .catch((error) => {
                     dispatch({type: 'GET_STAFF_MEMBER_REJECTED', payLoad: error.data})
                   });
};

export const saveStaffMember = (payLoad, saveLink) => {
  store.dispatch({type: "SAVE_STAFF_MEMBER_PENDING"});
  return irelandApi.patch(saveLink, {my_staff_member: assembleStaffMember(payLoad)})
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success" message="Staff member has been saved successfully"/>);
                     store.dispatch(actions.reset('deep.staff_member'));
                     store.dispatch(getStaff());
                     store.dispatch({type: "SAVE_STAFF_MEMBER_FULFILLED", payLoad: response.data});
                   })
                   .catch((error) => {
                     store.dispatch({type: "SAVE_STAFF_MEMBER_REJECTED"});
                     store.dispatch(actions.resetValidity('deep.staff_member'));
                     toast.error(<ToastMessage iconStyle="error" message="An error occured during save"/>);
                     const data = {
                       ...error.response.data.errors
                     };
                     return Promise.reject(data)
                   });
};

export const removeStaffMember = (removeLink, id, outletId) => (dispatch) => {
  dispatch({type: "REMOVE_STAFF_MEMBER_PENDING"});
  return irelandApi.post(removeLink, {my_staff_member:{outlet_id: outletId}})
                   .then((response) => {
                      toast.success(<ToastMessage iconStyle="success" message="Staff member has been removed successfully"/>);
                      dispatch({type: "REMOVE_STAFF_MEMBER_FULFILLED", payLoad: response.data, id: id});
                   })
                   .catch((error) => {
                      toast.error(<ToastMessage iconStyle="error" message="An error occured during remove"/>);
                      dispatch({type: 'REMOVE_STAFF_MEMBER_REJECTED', payLoad: error.data})
                   });
};


export const getRewardRedemptions = (keywords, dateFrom, dateTo, autoredemption, page = '') => (dispatch) => {
  dispatch({
    type: "GET_REWARD_REDEMPTIONS_PENDING",
    payLoad: []
  });

  let q = {
    search: keywords,
    redemption_date_from: dateFrom,
    redemption_date_to: dateTo,
    autoredemption: autoredemption
  };
  return irelandApi.get(`/api/admin/redemptions?${qs.stringify({q: q}, {encodeValuesOnly: true})}&page=${page}`)
                   .then((response) => {
                     dispatch({
                       type: "GET_REWARD_REDEMPTIONS_FULFILLED",
                       payLoad: response.data
                     });
                   })
                   .catch((error) => {
                     dispatch({
                       type: 'GET_REWARD_REDEMPTIONS_REJECTED',
                       payLoad: error.data
                     })
                   });
};

export const getStaffRewardSettings = () => (dispatch) => {
  dispatch({
    type: "GET_REWARD_SETTINGS_PENDING",
    payLoad: []
  });
  return irelandApi.get(`/api/admin/staff_reward_settings`)
                   .then((response) => {

                     const attributes = response.data.data.attributes;
                     let firstDate = attributes['autoredemption-dates'].shift();
                     let settings = {
                       autoredemption_date:     firstDate,
                       autoredemption_dates:     attributes['autoredemption-dates'],
                       point_per_euro:    attributes['point-per-euro'],
                       reward_markup: attributes['reward-markup'],
                       available_vouchers: attributes['vouchers'],
                       threshold_start_date: attributes['threshold-start-date'],
                       threshold_duration: attributes['threshold-duration'],
                       max_vouchers_for_duration: attributes['max-vouchers-for-duration'],
                       max_voucher_value: attributes['max-voucher-value']
                     };
                     dispatch(actions.load('deep.admin_staff_reward.settings', settings));
                     dispatch({ type: "GET_REWARD_SETTINGS_FULFILLED",  payLoad: settings });
                   })
                   .catch((error) => {
                     dispatch({
                       type: 'GET_REWARD_SETTINGS_REJECTED',
                       payLoad: error.data
                     })
                   });
};

export const getVouchers = () => (dispatch) => {
  dispatch({
    type: "GET_VOUCHERS_PENDING",
    payLoad: []
  });
  return irelandApi.get(`/api/admin/voucher_types`)
                   .then((response) => {
                     dispatch({ type: "GET_VOUCHERS_FULFILLED",  payLoad: response.data.data});
                   })
                   .catch((error) => {
                     dispatch({
                       type: 'GET_VOUCHERS_REJECTED',
                       payLoad: error.data
                     })
                   });
};

export const saveStaffRewardSettings = (payLoad) => {

  let newAutoRedemptionDates = [payLoad.autoredemption_date, ...payLoad.autoredemption_dates];
  let vouchers = payLoad.available_vouchers.map(curr => curr.value);

  const data = {
    staff_reward_settings: {
      point_per_euro: payLoad.point_per_euro,
      reward_markup: payLoad.reward_markup,
      autoredemption_dates: newAutoRedemptionDates,
      available_vouchers: vouchers,
      threshold_start_date: payLoad.threshold_start_date,
      threshold_duration: payLoad.threshold_duration,
      max_vouchers_for_duration: payLoad.max_vouchers_for_duration,
      max_voucher_value: payLoad.max_voucher_value
    }
  };
  return irelandApi.patch('/api/admin/staff_reward_settings', { ...data })
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success" message="Staff Reward settings saved successfully"/>);
                     store.dispatch(actions.setValidity('deep.admin_staff_reward.settings', false));
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error" message="An error occurred during save Staff Reward settings"/>);
                     const data = {
                       ...error.response.data.errors
                     };

                     if(data.autoredemption_dates){
                       const invalidDates = {};
                       Object.keys(data.autoredemption_dates).forEach(key => {
                         invalidDates[key-1] = data.autoredemption_dates[key]
                       });

                       data.autoredemption_dates = invalidDates
                     }
                     return Promise.reject(data)
                   });
};

export const initPersonalRewardsForm = () => (dispatch) => {
  dispatch({
    type: "GET_PERSONAL_REWARDS_PENDING",
    payLoad: []
  });
  return irelandApi.get(`/api/personal_rewards`)
                   .then((response) => {
                     const attributes = response.data.data.attributes;
                     if (attributes['ppc-status'] === 'opted_in') {
                         const data = {
                             title: attributes.title,
                             first_name: attributes['first-name'],
                             last_name: attributes['last-name'],
                             date_of_birth: moment(attributes['date-of-birth'], "YYYY-MM-DD").format("DD/MM/YYYY"),
                             address_1: attributes['address-1'],
                             address_2: attributes['address-2'],
                             town: attributes.town,
                             county: attributes.county,
                             eircode: attributes.eircode,
                             store_name: attributes['store-name'],
                             email: attributes.email,
                             mobile: attributes.mobile
                         };
                         dispatch(actions.load('deep.personal_rewards', data));
                     }
                     dispatch({
                       type: "GET_PERSONAL_REWARDS_FULFILLED",
                       payLoad: response.data
                     });
                   })
                   .catch((error) => {
                     dispatch({
                       type: 'GET_PERSONAL_REWARDS_REJECTED',
                       payLoad: error.data
                     })
                   });
};

export const savePersonalRewards = (payLoad) => {
  const data = {
    ...payLoad,
    date_of_birth: moment(payLoad.date_of_birth, "DD/MM/YYYY").format("YYYY-MM-DD")
  };
  return irelandApi.post(`api/ppc_users`, {ppc_user: payLoad})
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success"
                                                 message="Personal rewards settings saved successfully"/>);
                     store.dispatch({type: 'TOGGLE_PERSONAL_REWARDS_SETTINGS_DIALOG', payLoad: false});
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error"
                                               message="An error occurred during save personal rewards settings"/>);
                     store.dispatch(actions.resetValidity('deep.personal_rewards'));
                     const data = {
                       ...error.response.data
                     };
                     return Promise.reject(data)
                   });
};

export const getStaffRewardOutlets = () => (dispatch) => {
    dispatch({type: "GET_STAFF_REWARDS_OUTLETS_PENDING", payload: []});
    return irelandApi.get('/api/staff_rewards')
                     .then((response) => {
                         dispatch({ type: 'GET_STAFF_REWARDS_OUTLETS_FULFILLED', payLoad: response.data });
                     })
                     .catch((error) => {
                         dispatch({type: 'GET_STAFF_REWARDS_OUTLETS_REJECTED', payLoad: error.data});
                         return Promise.reject(error.response.data);
                     });
};

export const getStaffRewardOutlet = (storeId, row) => (dispatch) => {
    dispatch({type: "GET_STAFF_REWARDS_OUTLET_PENDING", payLoad: []});
    return irelandApi.get(`/api/staff_rewards/${storeId}/manage`)
        .then((response) => {
            let attributes = response.data.data.attributes;
            let data = {
                auto_redeem: attributes['auto-redeem']
            };
            if (attributes['voucher-type'] !== null) {
                data['voucher_type_id'] = attributes['voucher-type'].id;
            } else {
                data['voucher_type_id'] = ''
            }
            if (attributes['voucher-denomination'] !== null) {
                data['voucher_denomination_id'] = attributes['voucher-denomination'].id
            } else {
                data['voucher_denomination_id'] = ''
            }
            const availableVoucherTypes = response.data.meta['available-voucher-types'].map((item) => {
                return {
                    value: item.id, label: item.name
                }
            });
            const availableVoucherDenominations = {};
            response.data.meta['available-voucher-types'].forEach((item) => {
                availableVoucherDenominations[item.id] = item.denominations.map((denomination) => {
                    return {
                        value: denomination.id, label: denomination.variant
                    }
                });
            });
            dispatch(actions.load('deep.staff_rewards', data));
            dispatch({ type: 'GET_STAFF_REWARDS_OUTLET_FULFILLED',
                       payLoad: {
                         storeId: storeId,
                         row: row,
                         rewardMarkup: attributes['reward-markup'],
                         availableVoucherTypes: availableVoucherTypes,
                         availableVoucherDenominations: availableVoucherDenominations
                       }
            });
        })
        .catch((error) => {
            dispatch({type: 'GET_STAFF_REWARDS_OUTLET_REJECTED', payLoad: error.data});
            return Promise.reject(error.response.data);
        });
};

export const saveStaffRewards = (payload, storeId) => {
    store.dispatch({type: "SAVE_STAFF_REWARDS_PENDING"});
    let data = { outlet: {...payload} };
    if (!payload['auto_redeem']) {
        data['outlet']['voucher_denomination_id'] = null;
    }
    return irelandApi.post(`/api/staff_rewards/${storeId}/save`, data)
        .then((response) => {
            toast.success(<ToastMessage iconStyle="success" message="Staff rewards has been saved successfully"/>);
            store.dispatch(actions.reset('deep.staff_rewards'));
            store.dispatch({type: "SAVE_STAFF_REWARDS_FULFILLED", payLoad: response.data});
        })
        .catch((error) => {
            store.dispatch({type: "SAVE_STAFF_REWARDS_REJECTED"});
            store.dispatch(actions.resetValidity('deep.staff_rewards'));
            toast.error(<ToastMessage iconStyle="error" message="An error occured during save"/>);
            const data = {
                ...error.response.data.errors
            };
            return Promise.reject(data)
        });
};



// WEBPACK FOOTER //
// ./src/actions/staff.js